import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-130b71f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center border-b-2 px-2 my-4 !w-full" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "chip-list !w-full" }
const _hoisted_4 = { class: "chip-container mx-auto w-full max-h-[20rem] overflow-y-scroll" }

import {ref, onBeforeMount, nextTick, computed} from "vue"
import tagViewer from "./tagViewer.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'statusChanger',
  props: ["statusList", "title", "existingStatuses", "displaysTriangle"],
  emits: ["cancelled", "updated"],
  setup(__props, { emit: __emit }) {


const statusChanger = ref<HTMLElement | null>(null)
const props = __props

const availableSelections = computed(() => {
    if(!props.existingStatuses || props.existingStatuses.length === 0) return props.statusList

    // Filter out the existing statuses from the status list, using the id property.

    return props.statusList.filter((status: any) => {
        return !props.existingStatuses.some((existingStatus: any) => existingStatus.id === status.id)
    })

})

const emits = __emit

const cancel = () => {
    emits("cancelled")
}

const updateStatus = (status: any) => {
    emits("updated", status)
}

onBeforeMount(() => {
    nextTick(() => {
        statusChanger.value.focus()
    })
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'display-triangle': __props.displaysTriangle}, "shadow-md outline-none z-30 rounded bg-[var(--box-color)] border text-2xl p-4"]),
    ref_key: "statusChanger",
    ref: statusChanger,
    tabindex: "0",
    onBlur: cancel
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("button", {
        onClick: _withModifiers(cancel, ["stop"]),
        class: "ml-auto text-2xl font-bold"
      }, "x")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableSelections.value, (v, k) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "single-chip-holder !w-full mb-4",
            key: k
          }, [
            _createVNode(tagViewer, {
              onClick: ($event: any) => (updateStatus(v)),
              class: "!w-full transition transform hover:scale-105 relative cursor-pointer",
              tag: v
            }, null, 8, ["onClick", "tag"])
          ]))
        }), 128))
      ])
    ])
  ], 34))
}
}

})